var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInvestedCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505759",
    fillRule: "evenodd",
    d: "M6 0a6 6 0 1 1 0 12A6 6 0 0 1 6 0Zm0 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1Zm2.866 3.15a.5.5 0 0 1 .051.639l-.058.068-3.477 3.405-1.785-2.44a.5.5 0 0 1 .747-.658l.06.068 1.102 1.507 2.653-2.596a.5.5 0 0 1 .707.007Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInvestedCheck);
export default ForwardRef;